import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import { getDates, getOnData } from "./Network_Calls.ondate";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Navbar from "../Navbar/Navbar";
import { useLocation } from 'react-router-dom';
import Button from "@mui/material/Button";
import { fetchTagDataOnDate } from '../Search/Network_Calls';


const OnDate = () => {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toLocaleString("default", {
      month: "long",
      day: "numeric",
    })
  );
  const [sortedDate, setSortedDate] = useState([]);
  const [loading, setLoading] = useState(true);
  const { implId, id } = useParams();
  const [data, setData] = useState([]);
  const [filteredList, setFilteredList] = useState([]); 
  const [selectedTag, setSelectedTag] = useState("");
  const now = new Date();
  const [day, month] = selectedDate.split(" ");
  const currentYear = new Date().getFullYear();
  const currentday = now
    .toLocaleString("default", {
      day: "numeric",
      month: "long",
    })
    .split(" ");

  const [currentDay, CurrentMonth] = currentday;
  console.log(selectedDate);

  const location = useLocation();
  const collectionTags = location.state?.collectionTags || [];
  console.log("tags", collectionTags);

  useEffect(() => {
    const dates = async () => {
      const result = await getDates(implId);
      if (result.status === 200) {
        const { date } = result.data;
        setSortedDate([...date]);
      }
    };
    const user = async () => {
      const result = await getOnData(implId, selectedDate);
      if (result.status === 200) {
        const { users } = result.data;
        setData([...users]);
        setLoading(false);
      }
    };

    
    user();
    dates();
  }, [implId]);

  console.log("gataaaaaaaaa", data)

  const filterData = async (tag) => {
    if (selectedTag === tag) {
      setSelectedTag("");
      setFilteredList([]);
      return;
    }
  
    setSelectedTag(tag);
    const allIds = data.flatMap((event) =>
      Object.values(event.data).flatMap((list) => list.map((item) => item.id))
    );
  
    if (allIds.length > 0) {
      const result = await fetchTagDataOnDate(allIds, tag);
      const Customer_id = result.customerIds;
  
      const filteredData = data.map((event) => {
        const filteredEventData = Object.entries(event.data).reduce(
          (acc, [key, value]) => {
            const filteredValue = value.filter((item) =>
              Customer_id.includes(item.id)
            );
            if (filteredValue.length > 0) {
              acc[key] = filteredValue;
            }
            return acc;
          },
          {}
        );
  
        return { ...event, data: filteredEventData };
      });
  
      // Set filtered data to state
      setFilteredList(filteredData);
    }
  };
  
  const handleDateChange = async (event) => {
    const date = new Date(event.target.value);
    setSelectedDate(event.target.value);
    const result = await getOnData(implId, event.target.value);
    if (result.status === 200) {
      const { users } = result.data;

      setData([...users]);
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />

      {implId && (
        <>
          <div
            style={{ marginLeft: "10px", marginTop: "20px", display: "flex",justifyContent:"center",gap:"50px" }}
          >
            <div>
              <h3 style={{ color: "#FF762B", fontWeight: "bold" }}>
                On This Day
              </h3>
              <h4>
                <span>{month}</span> <span>{day}</span>
              </h4>
            </div>
            <select
              value={selectedDate}
              onChange={handleDateChange}
              style={{
                padding: "0px 4px",
                height:"50px",
                fontSize: "16px",
                border: "0.5px solid #ccc",
                borderRadius: "4px",
              }}
            >
              <option
                value={`${currentDay} ${CurrentMonth}`}
                style={{ fontWeight: "bold" }}
              >
                {currentDay} {CurrentMonth} (current date)
              </option>
              {sortedDate.map((date, index) => (
                <option key={index} value={date}>
                  {date}
                </option>
              ))}
            </select>
          </div>
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent:"center", margin:"1rem" }}>
            {collectionTags.map((tag, index) => (
              <button 
                key={index} 
                onClick={() => filterData(tag)}
                style={{ 
                  backgroundColor: selectedTag === tag ? "#000" : "#DCD8D5", 
                  color: selectedTag === tag ? "#fff" : "#000", 
                  border:"None"
                }}
              >
                {tag.tags}
              </button>
            ))}
          </div>
          <div style={{ marginLeft: "-300px",marginTop:"40px" }}>
            {" "}
            <Timeline>
              {loading ? (
                <Box sx={{ display: "flex" }}>{/* <CircularProgress /> */}</Box>
              ) : (
                <>
                  {filteredList.length !== 0 ? (
                    filteredList.map((event, index) => (
                      <TimelineItem key={index} position="alternate">
                        <TimelineSeparator>
                          <TimelineDot variant="outlined" color="primary" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "0", px: 2 }}>
                          <Typography variant="h6" component="span">
                            {event.year}
                          </Typography>
                          <p style={{ fontSize: "0.75em", color: "grey" }}>
                            {event.yearDifference}
                          </p>
                          {event.data ? (
                            <>
                              {Object.entries(event.data).map(
                                ([key, value]) => (
                                  <>
                                    {key === "Closed Won" ? (
                                      <h6
                                        style={{
                                          color: "#FF762B",
                                          fontSize: "16px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Celebrated
                                      </h6>
                                    ) : key === "Connected" ? (
                                      <>
                                        <br></br>
                                        <h6
                                          style={{
                                            color: "#FF762B",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Grew Network
                                        </h6>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {value.length !== 0 && (
                                      <>
                                        {value.map((e) => (
                                          <Typography>
                                            <span>{e.status}</span> -{" "}
                                            <span>{e.stage}</span> -{" "}
                                            <span
                                              style={{
                                                color: "#FF762B",
                                                color: "#22848F",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {e.username}
                                            </span>
                                          </Typography>
                                        ))}
                                      </>
                                    )}
                                  </>
                                )
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </TimelineContent>
                      </TimelineItem>
                    ))
                  ) : (
                    data.map((event, index) => (
                      <TimelineItem key={index} position="alternate">
                        <TimelineSeparator>
                          <TimelineDot variant="outlined" color="primary" />
                          <TimelineConnector />
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: "0", px: 2 }}>
                          <Typography variant="h6" component="span">
                            {event.year}
                          </Typography>
                          <p style={{ fontSize: "0.75em", color: "grey" }}>
                            {event.yearDifference}
                          </p>
                          {event.data ? (
                            <>
                              {Object.entries(event.data).map(
                                ([key, value]) => (
                                  <>
                                    {key === "Closed Won" ? (
                                      <h6
                                        style={{
                                          color: "#FF762B",
                                          fontSize: "16px",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Celebrated
                                      </h6>
                                    ) : key === "Connected" ? (
                                      <>
                                        <br></br>
                                        <h6
                                          style={{
                                            color: "#FF762B",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Grew Network
                                        </h6>
                                      </>
                                    ) : (
                                      ""
                                    )}
                                    {value.length !== 0 && (
                                      <>
                                        {value.map((e) => (
                                          <Typography>
                                            <span>{e.status}</span> -{" "}
                                            <span>{e.stage}</span> -{" "}
                                            <span
                                              style={{
                                                color: "#FF762B",
                                                color: "#22848F",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              {e.username}
                                            </span>
                                          </Typography>
                                        ))}
                                      </>
                                    )}
                                  </>
                                )
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </TimelineContent>
                      </TimelineItem>
                    ))
                  )}
                </>
              )}
            </Timeline>
          </div>
        </>
      )}
    </div>
  );
};

export default OnDate;